import { AuthConfig } from 'angular-oauth2-oidc';
import { SIGNED_OUT_ROUTE } from '@assets/shared';

import { environment } from '../environments/environment';

/**
 * private interface for appSettings
 */
interface AppSettings {
  version: string;
  release: string;
  stage: string;
  isProduction: boolean;
  endpoints: {
    assets: {
      assets: string;
      depots: string;
      priceAlerts: string;
      transactions: string;
      overviews: string;
    },
    newsFeedArticles: {
      newsFeedArticles: string;
    }
    masterData: {
      currencies: string;
      countries: string;
      federalStates: string;
      enumValues: string;
      keywords: string;
      statusValues: string;
    },
    messaging: {
      channelRegistrations: string;
    },
    realEstates: {
      buildings: string;
      bookingCategories: string;
      bookingItems: string;
      depreciations: string;
      loanAgreements: string;
      units: string;
      overviews: string;
    }
  };
  authentication: {
    oidc: AuthConfig;
  };
}

export const appSettings: AppSettings = {
  version: '1.3.0',
  release: 'Release 30.09.2026',
  stage: environment.stage,
  isProduction: environment.production,
  authentication: {
    oidc: {
      issuer: environment.oidc.authority + '/',
      redirectUri: environment.baseUrls.uiUrl,
      // The signed-out page, not the application root. Returning to the root would start a new
      // sign-in and the sign-out would last one redirect. **This address has to be registered in
      // Cardinal as a post logout redirect uri**, or the logout ends on Cardinal's own page.
      postLogoutRedirectUri: environment.baseUrls.uiUrl + SIGNED_OUT_ROUTE,
      clientId: environment.oidc.clientId,
      scope: environment.oidc.scope,
      // Authorization code flow with PKCE. The library switches PKCE on by itself once the response
      // type contains 'code' and produces S256; there is nothing to configure and no flag to set.
      //
      // Gone with the flow: silentRefreshRedirectUri, which has no purpose without the iframe, and
      // clearHashAfterLogin, which only ever applied to a fragment response -- the code comes back in
      // the query string and the library clears it with history.replaceState.
      responseType: 'code',
      customTokenParameters: ['app_metadata', 'user_metadata', 'AccountId', 'email', 'name', 'sub', 'TenantId', 'PreferredLanguage', 'UserAccountGuid', 'AccountName'],
      requireHttps: environment.oidc.requireHttps
    }
  },
  endpoints: {
    assets: {
      assets: environment.baseUrls.assetsUrl + '/assets/',
      depots: environment.baseUrls.assetsUrl + '/depots/',
      priceAlerts: environment.baseUrls.assetsUrl + '/assets/pricealerts/',
      transactions: environment.baseUrls.assetsUrl + '/assets/transactions/',
      overviews: environment.baseUrls.assetsUrl + '/overviews/'
    },
    newsFeedArticles: {
      newsFeedArticles: environment.baseUrls.assetsUrl + '/newsfeedarticles/'
    },
    masterData: {
      currencies: environment.baseUrls.assetsUrl + '/currencies/',
      countries: environment.baseUrls.assetsUrl + '/countries/',
      federalStates: environment.baseUrls.assetsUrl + '/federalstates/',
      enumValues: environment.baseUrls.assetsUrl + '/enumvalues/',
      keywords: environment.baseUrls.assetsUrl + '/keywords/',
      statusValues: environment.baseUrls.assetsUrl + '/statusvalues/'
    },
    messaging: {
      channelRegistrations: environment.baseUrls.assetsUrl + '/messagingchannelregistrations/'
    },
    realEstates: {
      buildings: environment.baseUrls.assetsUrl + '/realestates/buildings/',
      bookingCategories: environment.baseUrls.assetsUrl + '/realestates/bookingcategories/',
      bookingItems: environment.baseUrls.assetsUrl + '/realestates/bookingitems/',
      depreciations: environment.baseUrls.assetsUrl + '/realestates/depreciations/',
      loanAgreements: environment.baseUrls.assetsUrl + '/realestates/loanagreements/',
      units: environment.baseUrls.assetsUrl + '/realestates/buildings/units/',
      overviews: environment.baseUrls.assetsUrl + '/realestates/overviews/'
    }

  }
};
